module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"title":"Velg<br> dine interesser","label":"Personlig"},"en":{"title":"Choose<br> your interests","label":"Personal"}}')
  delete Component.options._Ctor
}
